import React, { useState } from 'react';
import { API } from '@aws-amplify/api';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import EditIcon from "@mui/icons-material/Edit";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function handleChange() {

}


const CloudId = (props) => {

  const [modelOpen, setModalOpen] = React.useState(false);
  const [value, setValue] = useState(""); 
  const [secondValue, setSecondValue] = useState(""); 
  const [result, setResult] = useState("");
  const [response, setResponse] = useState('');
  const [formHidden, setformHidden] = useState(false);

  console.log(props);
  var ucs = props.ucs;
  console.log('ucs prop in ',ucs);
  // State variables to hold form input values and server response
  const [formData, setFormData] = useState({
    customer: ucs.customer.customer_id.S,
    cloud: 'cloud id here',
    confirmed: 'confirm again...',
    encoded: ''
  });


  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))


  // Function to handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  /*
   headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json"
      }, 
  */

  async function saveCloudData(saveData) {
    console.log('starting the save',saveData)
    const apiName = 'apic48d2c9b'; 
    const path = '/cloud';
    const myInit = {
      body: saveData,
      headers: {}, 
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };
    return API.put(apiName, path, myInit);
  }

  function myEncoding(c,p) {
    var cred_string = c + ";" + p;   
    var u = btoa(cred_string);
    var cleansed = u.replace(/=/g, "");
    console.log(cred_string + "=" + cleansed);
    return cleansed;
  }

  function handleModalOpen() {
    setModalOpen(true);
    setformHidden(false);
  }

  function handleModalClose() {
    setModalOpen(false);
  }

  function modalCancel() {
    setModalOpen(false);
  }

  function handleCredentialEntry(e) { 
   
    console.log(' change in id as value ', e.target.id, e.target.value);
    if (e.target.id === "first") {
      setValue(e.target.value); 
      setResult('');
    }
    if (e.target.id === "second") {
      setSecondValue(e.target.value); 
      setResult(""); 
    }
   
  } 

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    
    console.log('handling submit here', value, secondValue);
    if  (value===secondValue) {
      console.log('would save');
      setformHidden(true);
      setResponse('Saving data now....');
      var myCred = myEncoding(formData.customer, formData.cloud);
      formData.encoded = myCred;
      setFormData(formData);
      setformHidden(true);
      var post_save_response = await saveCloudData(formData);
      if (post_save_response.status === 200 ) {
        const date_string_now = new Date(post_save_response.data.timestamp);
        setResponse('Successfully saved on ' + date_string_now.toLocaleString('en-US') + " local time.");
        console.log(post_save_response);       
        await sleep(3000)
        setModalOpen(false);
       
      } else {
        setResponse(post_save_response.statusText);
      }

    }
    else {
      console.log('pwd no match');
      setResult('cloud credential and confirm must match');
    }

};


// Function to handle form submission
  const handleFinalSubmit = async (e) => {
    e.preventDefault();    
    if (formData.cloud === formData.confirmed) {
      setResponse('Posting to save');
      var myCred = myEncoding(formData.customer, formData.cloud);
      formData.encoded = myCred;
      setFormData(formData);
      var post_save_response = await saveCloudData(formData);
      if (post_save_response.status === 200 ) {
        const date_string_now = new Date(post_save_response.data.timestamp);
        setResponse('Successfully saved on ' + date_string_now.toLocaleString('en-US'));
        
        console.log(post_save_response);
      } else {
        setResponse(post_save_response.statusText);
      }
    } 
    else {
      setResult('cloud credential and confirm must match');
    }
  };

  return (
    <div>     
      <Button onClick={handleModalOpen}>
        <p style={{ marginLeft: "5%" }}>Edit</p>
        <EditIcon></EditIcon>
      </Button>

      {response && <p>{response}</p>}

      <Modal
            open={modelOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Edit Fleet Id Credential
              </Typography>
              <div id="formgoeshere" hidden={formHidden}>

              <form onSubmit={handleSubmit}> 
                <label>Credential</label> 
                <input 
                    type="password"
                    id="first"
                    value={value} 
                    onInput={handleCredentialEntry} 
                    required 
                />
                 <br /> 
                Repeat to confirm
                <input 
                    type = "password"
                    id="second"
                    value={secondValue} 
                    onInput={handleCredentialEntry} 
                    required 
                />

                <br /> 
                <br />
                <button id="canSave" type="submit" >Save</button>
            </form> 
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <Button
                  style={{ width: 20, height: 20, padding: 20 }}
                  onClick={() => modalCancel()}
                >
                  CANCEL{" "}
              </Button>               
              </Typography>
            <div> 
                <h4>{result}</h4> 
                {response && <p>{response}</p>}
            </div> 
            </Box>
      </Modal>
    </div>
  );
};

export default CloudId;
